import React from 'react';
import PropTypes from 'prop-types';
import Schema from './Schema';
import Sample from './Sample';

const exampleTypeEnum = {
	none: 'none',
	sample: 'sample',
	schema: 'schema'
};

class ApiExample extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isVisible: false,
			exampleType: exampleTypeEnum.none
		};
	}

	toggleVisibility = () => {
		const currentState = this.state.isVisible;
		this.setState({ isVisible: !currentState });
	}

	displaySchema = () => {
		if (this.state.exampleType !== exampleTypeEnum.schema)
			this.setState({ isVisible: true, exampleType: exampleTypeEnum.schema });
		else
			this.toggleVisibility();
	}

	displaySample = () => {
		if (this.state.exampleType !== exampleTypeEnum.sample)
			this.setState({ isVisible: true, exampleType: exampleTypeEnum.sample });
		else
			this.toggleVisibility();
	}

	render() {
		//extract props and state
		const { exampleType } = this.state;
		return (
			<div className={this.state.isVisible ? 'visibility-visible' : 'visibility-invisible'} style={{ display: 'inline' }}>
				<button className='example-expand' onClick={this.displaySample}>Show Sample (Experimental)</button>
				<button className='example-expand' onClick={this.displaySchema}>Show Schema (Experimental)</button>
				<div className='visibility-subject'>
					{(() => {
						switch (exampleType) {
							case exampleTypeEnum.sample: return <Sample apiItem={this.props.apiItem} />;
							case exampleTypeEnum.schema: return <Schema apiItem={this.props.apiItem.name} />;
							default: break;
						}
					})()}
				</div>
			</div>
		);
	}
}

ApiExample.propTypes = {
	apiItem: PropTypes.object.isRequired
};

export default ApiExample;


// WEBPACK FOOTER //
// ./src/components/api/ApiExample.js